(ns frontend.actions.named-value
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->archive! [data on-success! on-error!]
  (-> (conn/sendp! :named-value/archive data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->unarchive! [data on-success! on-error!]
  (-> (conn/sendp! :named-value/unarchive data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->merge! [data on-success! on-error!]
  (-> (conn/sendp! :named-value/merge data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->merge-per-pipeline! [data on-success! on-error!]
  (-> (conn/sendp! :named-value/merge-per-pipeline data)
      (p/then on-success!)
      (p/catch on-error!)))
